// components/RequestAccess/RequestAccessModal.jsx
import React, { useState } from "react";
import { Input, Button, notification } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { requestAccessApi } from "../../api/auth";

export default function RequestAccessModal({
  defaultEmail = "",
  onClose,
  defaultPassword = "",
}) {
  const [email, setEmail] = useState(defaultEmail);
  const [password, setPassword] = useState(defaultPassword);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleRequest = async () => {
    if (loading) {
      return;
    }

    if (!email) {
      notification.error({ message: "Please enter an email address" });
      return;
    }
    if (!password) {
      notification.error({ message: "Please enter a password" });
      return;
    }
    if (password !== confirmPassword) {
      notification.error({ message: "Passwords do not match" });
      return;
    }

    try {
      setLoading(true);
      const result = await requestAccessApi({ email, password });

      if (result.code === -1) {
        notification.error({ message: result.message });
      } else if (result.code === 0) {
        notification.success({ message: result.message });
        onClose?.(); // Close modal on success
      }
    } catch (error) {
      console.log("Error requesting access", error);
      notification.error({ message: "Error requesting access" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        marginTop: "1rem",
      }}
    >
      <label className="loginInputLabel">Email</label>
      <Input
        placeholder="Enter your email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        type="email"
        allowClear
        autoComplete="username"
      />

      <label className="loginInputLabel">Password</label>
      <Input.Password
        placeholder="Enter your password"
        name="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        autoComplete="new-password"
        iconRender={(visible) =>
          visible ? (
            <EyeTwoTone twoToneColor="#1890ff" />
          ) : (
            <EyeInvisibleOutlined />
          )
        }
      />

      <label className="loginInputLabel">Repeat Password</label>
      <Input.Password
        placeholder="Repeat your password"
        name="confirmPassword"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        autoComplete="new-password"
        iconRender={(visible) =>
          visible ? (
            <EyeTwoTone twoToneColor="#1890ff" />
          ) : (
            <EyeInvisibleOutlined />
          )
        }
      />

      <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
        <Button
          type="primary"
          loading={loading}
          onClick={handleRequest}
          className="login-form__button"
        >
          Request
        </Button>
      </div>
    </div>
  );
}
